import { Mail, DownloadCloud } from 'styled-icons/feather'
import { Card, Grid, Title, Paragraph, SubTitle } from '@bidalihq/ui';
import tw from 'tailwind-styled-components';

import Section from '@/components/section';

const CardTitle = tw(SubTitle)`
  leading-none
  mx-0
  my-0
  mb-2
  p-4
`;

const Hero = () => {
  return (
    <Section className="md:pb-0 pb-0">
      <Title className="text-brand-primary">Press Resources</Title>
      <SubTitle>News, company info, and media resources.</SubTitle>
      <Grid className="gap-6 mt-12" columns={[1, 2]}>
        <Card
          actions={[{
            icon: <Mail />,
            label: 'press@bidali.com',
            onClick: () => {
              if (typeof window !== 'undefined')  {
                window.open('mailto:press@bidali.com');
              }
            }
          }]}
          header={<CardTitle>Press Contact</CardTitle>}
        >
          <Paragraph>Need more information for your story, feel free to reach out!</Paragraph>
        </Card>
        <Card
          actions={[{
            icon: <DownloadCloud />,
            label: 'Download Press Kit',
            onClick: () => {
              if (typeof window !== 'undefined')  {
                window.open('/bidali-press-kit.zip');
              }
            }
          }]}
          header={<CardTitle>Brand Assets</CardTitle>}
        >
          <Paragraph>Download our entire press kit including company logos, founder information and everything you should need for your story.</Paragraph>
        </Card>
      </Grid>
    </Section>
  );
};

export default Hero;
